export default __webpack_public_path__ + "static/media/completed_female@3x.48601118.png";